import script from "./BlueCubesRoundedIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./BlueCubesRoundedIcon.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__